import type { ColDef } from 'ag-grid-community';
import type { IntlKey } from 'locales';
import type { IBlotterItem } from 'models/IBlotterItem';

export const canSetActive = (cell: ColDef<IBlotterItem> | null): boolean =>
  cell?.cellRenderer !== 'buttonRenderer' && cell?.field !== 'addToOrderBasket';

export const getHeaderForBlotterIntlKey = (blotterName: string) => (key: string) =>
  `${blotterName}.column.header.${key}` as IntlKey;
